import Vue from 'vue'
import App from './App.vue'
import store from "./store/store.js"
import router from './router'
import './styles/public.css'
import 'vant/lib/index.css'
import { Toast } from 'vant';
Vue.use(Toast);
import * as echarts from 'echarts'
Vue.prototype.$echarts=echarts
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
// 路由发生变化修改页面title
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
